(() => {
  'use strict';

  const gate = document.querySelector('[data-research-gate]');
  if (!gate) return;

  const cookieName = 'raw_research_gate';
  const cookieValue = 'accepted';
  const form = gate.querySelector('[data-research-gate-form]');
  const button = gate.querySelector('[data-research-gate-enter]');
  const status = gate.querySelector('[data-research-gate-status]');
  const checkboxes = Array.from(form.querySelectorAll('input[type="checkbox"][required]'));
  let previouslyFocused = null;

  const hasAccepted = () => document.cookie
    .split('; ')
    .some((item) => item.startsWith(`${cookieName}=${cookieValue}`));

  const saveAcceptance = () => {
    const configuredDays = Number.parseInt(gate.dataset.cookieDays, 10);
    const days = Number.isFinite(configuredDays) && configuredDays > 0 ? configuredDays : 60;
    const maxAge = days * 24 * 60 * 60;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${cookieName}=${cookieValue}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  };

  const setPageLocked = (locked) => {
    document.documentElement.classList.toggle('rr-gate-required', locked);
    document.body.classList.toggle('rr-gate-is-open', locked);
  };

  const updateButton = () => {
    const complete = checkboxes.every((checkbox) => checkbox.checked);
    button.disabled = !complete;
    button.setAttribute('aria-disabled', String(!complete));
    status.textContent = complete
      ? 'All certifications complete. You may enter the research platform.'
      : 'Complete all four certifications to enter.';
  };

  const focusableElements = () => Array.from(gate.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hasAttribute('hidden'));

  const trapFocus = (event) => {
    if (event.key !== 'Tab' || gate.hidden) return;

    const focusable = focusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const openGate = () => {
    previouslyFocused = document.activeElement;
    gate.hidden = false;
    gate.setAttribute('aria-hidden', 'false');
    setPageLocked(true);
    updateButton();

    window.requestAnimationFrame(() => {
      const firstCheckbox = checkboxes[0];
      if (firstCheckbox) firstCheckbox.focus({ preventScroll: true });
    });
  };

  const closeGate = () => {
    gate.classList.add('is-leaving');
    gate.setAttribute('aria-hidden', 'true');
    setPageLocked(false);

    window.setTimeout(() => {
      gate.hidden = true;
      gate.classList.remove('is-leaving');

      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus({ preventScroll: true });
      }
    }, 540);
  };

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateButton);
  });

  gate.querySelectorAll('.rr-gate__certification a').forEach((link) => {
    link.addEventListener('click', (event) => event.stopPropagation());
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    if (!checkboxes.every((checkbox) => checkbox.checked)) {
      updateButton();
      const firstUnchecked = checkboxes.find((checkbox) => !checkbox.checked);
      if (firstUnchecked) firstUnchecked.focus();
      return;
    }

    saveAcceptance();
    closeGate();
  });

  gate.addEventListener('keydown', trapFocus);

  if (hasAccepted()) {
    gate.hidden = true;
    gate.setAttribute('aria-hidden', 'true');
    setPageLocked(false);
  } else {
    openGate();
  }
})();
